import { find, toLower } from 'lodash/fp';

import { HealthFormValues } from '../../../home/types';
import { INCOME_TIER_NONE } from '../../../../components/pricing-drawer/constants';
import { LeadInput } from '../../../../types/leads';
import { LeadSourceType } from '../../../../utils/create-lead/types';
import { RefinePriceSchemaType } from '../../form/schema';
import AgrService from '../../../../models/agr';
import buildLeadUrl from '../../../../utils/build-lead-url';
import constants from '../../../../ahm-constants';
import createLead from '../../../../utils/create-lead';
import getAgrAgeBracketFromAge from '../../../../utils/get-agr-age-bracket-from-age';
import getIncomeBracket from '../../../../utils/get-income-bracket';
import logging from '../../../../logging';

const submitRefinePriceLead = async ({
  formValues,
  leadSourceType,
}: {
  formValues: RefinePriceSchemaType | HealthFormValues;
  leadSourceType: LeadSourceType;
}) => {
  try {
    const { age, email, incomeTier, incomeType, name, partnerAge, phone, productType, rebate, scale, state } =
      formValues;

    // Drop lead if no email and no phone is provided
    if (!email && !phone) return;

    // RefinePriceSchemaType has frequency but HealthFormValues does not. Aligning these schemas will resolve this
    const frequency = Object.hasOwn(formValues, 'frequency') ? (formValues.frequency as string) : undefined;
    const numericAge = Number(age);
    const numericPartnerAge = partnerAge ? Number(partnerAge) : 0;
    const effectiveIncomeTier = rebate ? incomeTier : INCOME_TIER_NONE;
    const ageBracket = getAgrAgeBracketFromAge(Math.max(numericAge, numericPartnerAge));
    const ageBracketOption = find({ value: ageBracket }, constants.REBATE_AGE_BRACKET_OPTIONS);
    const rebatePercentage = AgrService.getPercentage({ ageBracket, incomeTier: effectiveIncomeTier, rebate });
    const rebateAgeBracket = ageBracketOption ? toLower(ageBracketOption.text) : undefined;
    const url = buildLeadUrl(window.location.pathname, {
      age: numericAge,
      frequency,
      incomeTier: effectiveIncomeTier,
      incomeType,
      partnerAge: numericPartnerAge || undefined,
      scale,
      state,
    });
    const incomeBracket = getIncomeBracket(effectiveIncomeTier, rebate, incomeType) ?? undefined;

    const leadInput: LeadInput = {
      age: numericAge,
      email: email ?? '',
      frequency,
      incomeBracket,
      incomeTier: effectiveIncomeTier,
      incomeType,
      marketingOptIn: true,
      name: name ?? '',
      partnerAge: partnerAge ? Number(partnerAge) : undefined,
      phone: phone ?? '',
      productType,
      rebateAgeBracket,
      rebateAgeTier: ageBracket,
      rebatePercentage,
      scale,
      state,
      url,
    };

    await createLead({ leadInput, sourceType: leadSourceType });
  } catch (error) {
    logging.getLogger().error('Failed to submit refine price lead', {
      error,
    });
  }
};

export default submitRefinePriceLead;
